import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { pathgen } from 'object-path-generator';
import { useResponsive } from "../../contexts";
import { CreateAVendorAccount } from "../../../components/NavigationAndStructure/TopBar/components/CreateAVendorAccount";
import { useStoreActions } from "../../../contexts";
import styles from "./TryAnchorBanner.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const TryAnchorBannerDataTestIds = pathgen('TryAnchorBannerDataTestIds');
const TryAnchorBanner = _ref => {
  let {
    showBanner,
    isFixed
  } = _ref;
  const {
    isDesktop
  } = useResponsive();
  const {
    logBI
  } = useStoreActions();
  return /*#__PURE__*/_jsx(AnimatePresence, {
    children: showBanner && /*#__PURE__*/_jsx(motion.div, {
      className: cn(styles.bannerWrapper, {
        [styles.desktop]: isDesktop,
        [styles.mobile]: !isDesktop,
        [styles.notFixed]: !isFixed
      }),
      initial: {
        y: 32,
        opacity: 0
      },
      animate: {
        y: 0,
        opacity: 1
      },
      exit: {
        y: 32,
        opacity: 0
      },
      transition: {
        y: {
          type: 'spring',
          duration: 0.5,
          bounce: 0.25
        },
        opacity: {
          duration: 0.05,
          ease: 'linear'
        }
      },
      children: /*#__PURE__*/_jsx(CreateAVendorAccount, {
        variant: "banner",
        onClick: () => logBI(18105),
        testId: TryAnchorBannerDataTestIds.CreateVendorAccountBtn()
      })
    })
  });
};
export default TryAnchorBanner;